module.exports = __webpack_public_path__ + "img/success.f257a574.gif";